export default __webpack_public_path__ + "static/media/img-0378-switzerland-full-face.fa395d8b.png";